export default __webpack_public_path__ + "static/media/foto_06.648fb666.jpg";